/*
 * RDA-184 - Hide price and add to cart in Searchanise widgets (autocomplete
 * and search results) for products excluded in the current market
 * (metafield custom.mercati_esclusi). Searchanise renders its own markup in JS,
 * so the Liquid guards of the theme do not apply there.
 * Each product is checked once through the Section Rendering API
 * (sections/market-excluded-flag.liquid) and the result is cached per market.
 */
(() => {
  const PRODUCT_SELECTOR = '.snize-product';
  const CHECKED_ATTR = 'data-rda-market-checked';
  const EXCLUDED_CLASS = 'rda-market-excluded';
  const market = window.rdaMarketHandle || '';
  const storageKey = `rda-market-excluded:${market}`;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  let cache = {};
  try {
    cache = JSON.parse(sessionStorage.getItem(storageKey)) || {};
  } catch (e) {
    cache = {};
  }
  const pending = {};

  const saveCache = () => {
    try {
      sessionStorage.setItem(storageKey, JSON.stringify(cache));
    } catch (e) {}
  };

  const getHandle = (item) => {
    const link = item.querySelector('a[href*="/products/"]');
    if (!link) return null;
    const match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  };

  const isExcluded = (handle) => {
    if (handle in cache) return Promise.resolve(cache[handle]);
    if (!pending[handle]) {
      pending[handle] = fetch(`${root}products/${encodeURIComponent(handle)}?section_id=market-excluded-flag`)
        .then((response) => (response.ok ? response.text() : ''))
        .then((html) => {
          cache[handle] = html.includes('data-market-excluded="true"');
          saveCache();
          return cache[handle];
        })
        .catch(() => false)
        .finally(() => {
          delete pending[handle];
        });
    }
    return pending[handle];
  };

  const processItem = (item) => {
    if (item.hasAttribute(CHECKED_ATTR)) return;
    const handle = getHandle(item);
    if (!handle) {
      item.setAttribute(CHECKED_ATTR, '');
      return;
    }
    item.setAttribute(CHECKED_ATTR, 'pending');
    isExcluded(handle).then((excluded) => {
      item.classList.toggle(EXCLUDED_CLASS, excluded);
      item.setAttribute(CHECKED_ATTR, '');
    });
  };

  const scan = () => {
    document.querySelectorAll(`${PRODUCT_SELECTOR}:not([${CHECKED_ATTR}])`).forEach(processItem);
  };

  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      scan();
    });
  });

  const start = () => {
    scan();
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
